import ReactModal from "styled-react-modal";
import tw from "tailwind.macro";

const StyledModal = ReactModal.styled`
  ${tw`flex flex-col items-center p-0`}
  ${({ centered }) =>
    centered ? `${tw`justify-center`}` : `${tw`justify-between`}`}
`;

export default StyledModal;
